import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { getIssue, createIssue, updateIssue } from "../../api/issuesApi";
import { translateAuthError, API_ORIGIN } from "../../api/authApi";

// Section C (admin-only): shared create/edit form for a دریچه issue
// cover. Presence of the :id route param decides the mode — mirrors
// TopicFormPage.js/IssueTopicFormPage.js's pattern. On create the cover
// image is required; on edit, leaving the file input empty keeps the
// existing cover.
function IssueFormPage() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [number, setNumber] = useState("");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [existingImagePath, setExistingImagePath] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(isEdit);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!isEdit) return;
    getIssue(id)
      .then((issue) => {
        setNumber(String(issue.number));
        setTitle(issue.title);
        setExistingImagePath(issue.image_path || "");
      })
      .catch((err) => setError(translateAuthError(err.message)))
      .finally(() => setLoading(false));
  }, [id, isEdit]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");

    if (!isEdit && !file) {
      setError("انتخاب تصویر جلد الزامی است.");
      return;
    }

    const formData = new FormData();
    formData.append("number", number);
    formData.append("title", title);
    if (file) {
      formData.append("image", file);
    }

    setSubmitting(true);
    try {
      if (isEdit) {
        await updateIssue(token, id, formData);
      } else {
        await createIssue(token, formData);
      }
      navigate("/admin/issues");
    } catch (err) {
      setError(translateAuthError(err.message));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-page">
      <Link to="/admin/issues" className="back-link">
        ← بازگشت به فهرست شماره‌ها
      </Link>

      {loading ? (
        <p>در حال بارگذاری...</p>
      ) : (
        <form className="auth-card admin-article-form" onSubmit={handleSubmit}>
          <span className="corner corner-tr" />
          <span className="corner corner-tl" />
          <span className="corner corner-br" />
          <span className="corner corner-bl" />

          <h2>{isEdit ? "ویرایش شماره" : "شمارهٔ جدید"}</h2>

          {error && <p className="error">{error}</p>}

          <div className="auth-field">
            <label htmlFor="number">شماره</label>
            <input
              id="number"
              type="number"
              min="1"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              required
            />
          </div>

          <div className="auth-field">
            <label htmlFor="title">عنوان</label>
            <input id="title" type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>

          <div className="auth-field">
            <label htmlFor="image">تصویر جلد{isEdit ? " (اختیاری — برای تغییر)" : ""}</label>
            {existingImagePath && !file && (
              <img
                src={`${API_ORIGIN}${existingImagePath}`}
                alt=""
                className="admin-image-preview"
              />
            )}
            <input
              id="image"
              type="file"
              accept="image/png, image/jpeg, image/webp"
              onChange={(e) => setFile(e.target.files[0] || null)}
              required={!isEdit}
            />
          </div>

          <button type="submit" className="auth-submit" disabled={submitting}>
            {submitting ? "در حال ذخیره..." : isEdit ? "ذخیرهٔ تغییرات" : "بارگذاری شماره"}
          </button>
        </form>
      )}
    </div>
  );
}

export default IssueFormPage;
